import {Component, HostListener} from '@angular/core';
import {OwlOptions} from 'ngx-owl-carousel-o';
import emailjs, {type EmailJSResponseStatus} from '@emailjs/browser';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-home-two',
  templateUrl: './home-two.component.html',
  styleUrl: './home-two.component.css'
})
export class HomeTwoComponent {
  constructor( private http: HttpClient) {
  }
  // Features
  features = [
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient center-feature white-color border-radius-25",
      icon: "icon-laptop font-40px",
      title: "Mobile App",
      desc: "Mobile App for On-the-Go Sales & Management.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient-six center-feature white-color border-radius-25",
      icon: "icon-globe font-40px",
      title: "Web Site",
      desc: "Web App for Full ERP Control & Administration.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-gradient center-feature white-color border-radius-25",
      icon: "icon-dial font-40px",
      title: "Power BI",
      desc: "Power BI Integration for Advanced Data Analytics.",
    },
  ]

  // Our Process
  steps = [
    {
      icon: "icon-tools default-color font-30px",
      title: "Order Creation",
      desc: "Sales teams place orders through the mobile app or web portal anytime, anywhere."
    },
    {
      icon: "icon-globe default-color font-30px",
      title: "Stock Verification & Dispatch",
      desc: "Real-time inventory checks ensure accurate order fulfillment from depots or van sales."
    },
    {
      icon: "icon-mobile default-color font-30px",
      title: "Delivery & Payment Collection",
      desc: "Deliveries are tracked with proof of delivery, and payments are collected instantly via the mobile app."
    },
    {
      icon: "icon-browser default-color font-30px",
      title: "Accounting & Reporting",
      desc: "All data syncs to the ERP backend for seamless accounting and powerful business insights."
    },
  ]

  // Team

  slideStoreTwo: { title: string; subtitle: string; image: string; index: number }[] = [
    {
      title: "Web Designer",
      subtitle: "Tom Bills",
      image: "team-1.jpg",
      index: 0
    },
    {
      title: "CEO of Becki Agency",
      subtitle: "Sara Adams",
      image: "team-2.jpg",
      index: 1
    },
    {
      title: "Photographer",
      subtitle: "Enzo William",
      image: "team-3.jpg",
      index: 2
    }
  ];

  socialLinks = [
    {iconOuter: "facebook", iconInner: ['icofont icofont-social-facebook']},
    {iconOuter: "twitter", iconInner: ['icofont icofont-social-twitter']},
    {iconOuter: "pinterest", iconInner: ['icofont icofont-social-pinterest']},
  ];

  // Services
  services = [
    {
      icon: "icon-tools font-30px white-color",
      title: "ERP Implementation & Customization",
      desc: "Tailored ERP solutions designed specifically for your trading business.",
    },
    {
      icon: "icon-linegraph font-30px white-color",
      title: "Mobile & Web App Development",
      desc: "Robust, user-friendly mobile and web applications for seamless operations.",
    },
    {
      icon: "icon-globe font-30px white-color",
      title: "Data Analytics & Reporting",
      desc: "Power BI integration for insightful, real-time business analytics.",
    },
    {
      icon: "icon-tools font-30px white-color",
      title: "Training & Support",
      desc: "Expert training and continuous support to maximize ERP efficiency.",
    },
    {
      icon: "icon-beaker font-30px white-color",
      title: "System Maintenance & Upgrades",
      desc: "Regular updates and maintenance to keep your ERP running smoothly.",
    },
    {
      icon: "icon-layers font-30px white-color",
      title: "Consultation & Process Optimization",
      desc: "Professional guidance to improve your business workflows and maximize ROI.",
    },
  ]

  // Portfolio
  portfolios = [
    {
      img: "1.jpg",
      title: "Fode ",
      subTitle: "Branding, Mockup"
    },
    {
      img: "2.jpg",
      title: "Daniel and Denise",
      subTitle: "Branding, UI/UX"
    },
    {
      img: "3.jpg",
      title: "Sydney Design",
      subTitle: "Design, Stationery"
    },
    {
      img: "4.jpg",
      title: "Glasses",
      subTitle: "Branding, UI/UX"
    },
    {
      img: "5.jpg",
      title: "The Bijou Factory",
      subTitle: "Branding, Mockup"
    },
    {
      img: "6.jpg",
      title: "Calender",
      subTitle: "Design, Branding"
    },
    {
      img: "7.jpg",
      title: "Flyer",
      subTitle: "Branding, Stationery"
    },
    {
      img: "8.jpg",
      title: "Hand Watch",
      subTitle: "Design, UI/UX"
    }
  ]

  // Pricing
  pricing = [
    {
      title: "Basic",
      subTitle: "Affordable Plans for Every Business, Basic for essential ERP features",
      currency: "$",
      amount: 150,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Priority support',
        'Priority technical support',
        'WhatsApp group live chat',
        'System up & running responsibility',
        'Dedicated support manager',
        'Immediate system’s bug fixing',
      ]
    },

    {
      title: "Standard Plan",
      subTitle: "Affordable Plans for Every Business, Standard for advanced sales and inventory management.",
      currency: "$",
      amount: 250,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Priority support',
        'Priority technical support',
        'WhatsApp group live chat',
        'System up & running responsibility',
        'Dedicated support manager',
        'Immediate system’s bug fixing',
        '24*7 Live Support'
      ]
    },

    {
      title: "Extended Plan",
      subTitle: "Affordable Plans for Every Business,  Extended for full customization, analytics, and premium support",
      currency: "$",
      amount: 350,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Priority support',
        'Priority technical support',
        'WhatsApp group live chat',
        'System up & running responsibility',
        'Dedicated support manager',
        'Immediate system’s bug fixing',
        'Weekly follow-up meetings',
        'Needful customization',
        'Upcoming release roadmap',
        '24*7 Live Support'
      ]
    }
  ];

  // Owl Testimonial
  customOptionsThree: OwlOptions = {
    loop: true,
    dots: true,
    margin: 30,
    nav: true,
    autoplay: true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
        nav: false
      },
      1000: {
        items: 3,
      }
    }
  }

  slideStoreThree = [
    {
      title: "Anne McAdams",
      subTitle: "CEO / Founder",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sodales nec nulla ac aliquet. Duis vel nunc eget.",
      image: "assets/images/team/avatar-1.jpg",
    },

    {
      title: "Jared Kane",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-2.jpg",
    },

    {
      title: "Nani Wale",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-3.jpg",
    },

    {
      title: "John Doe",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-4.jpg",
    }

  ]

  // Owl Brand Logos
  customOptionsFour: OwlOptions = {
    loop: true,
    dots: false,
    margin: 0,
    nav: false,
    autoplay: true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 6,
      }
    }
  }

  slideStoreFour = [
    {
      image: "assets/images/clients/android-icon.svg",
    },

    {
      image: "assets/images/clients/firebase-icon.svg",
    },

    {
      image: "assets/images/clients/flutter-icon.svg",
    },

    {
      image: "assets/images/clients/ios-icon.svg",
    },

    {
      image: "assets/images/clients/laravel-icon.svg",
    },

    {
      image: "assets/images/clients/mysql-icon.svg",
    },
    {
      image: "assets/images/clients/php-icon.svg",
    }

  ]


  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'contact-form';  // Replace with your EmailJS Service ID
  private templateId = 'contact-form-becki';  // Replace with your EmailJS Template ID
  private publicKey = 'gObMl0a3V0Jib9k5c';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }
  apiData(event: Event) {
    event.preventDefault();
    const apiUrl = 'https://api.s1az.com/api/v4/send-email';
    this.http.post(apiUrl, this.formData).subscribe({
      next: (result: any) => {
        if (result.success) {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        }else {
          alert('Failed to send the message. Please try again later.');
        }

      },
      error: error => {
        console.log(error);
      },
      complete: () => {
      }
    });
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }

  socialMedia = [
    {
      iconClass: "fb",
      icon: "icofont icofont-social-facebook"
    },
    {
      iconClass: "tw",
      icon: "icofont icofont-social-twitter"
    },
    {
      iconClass: "be",
      icon: "icofont icofont-social-behance"
    },
    {
      iconClass: "in",
      icon: "icofont icofont-social-linkedin"
    },
    {
      iconClass: "yt",
      icon: "icofont icofont-social-youtube"
    },
    {
      iconClass: "ins",
      icon: "icofont icofont-social-instagram"
    }
  ]

  // Skills
  skills = [
    {name: 'Master Data Management', level: 100},
    {name: 'Procurement & Purchase', level: 80},
    {name: 'Sales & Distribution', level: 90},
    {name: 'Inventory & Stock Control', level: 80},
    {name: 'Accounting & Finance', level: 70},
    {name: 'CRM & Marketing', level: 70},
    {name: 'Logistics & Delivery', level: 50},
    {name: 'Reporting & Analytics', level: 80},
    {name: 'Admin & Security', level: 100},
  ];

  isScrolled = false;

  @HostListener('window:scroll', [])
  onScroll(): void {
    const skillsSection = document.querySelector('.skill');

    // Add a null check for skillsSection
    if (skillsSection) {
      const position = skillsSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if the section is in view
      if (position < windowHeight) {
        this.isScrolled = true;
      }
    }
  }

  // Video Popup
  isOpen = false;

  openPopup(): void {
    this.isOpen = true;
  }

  closePopup(): void {
    this.isOpen = false;
  }
}
